import { CommonDialogs, CommonTooltips } from "@mcleod/common";
import { StringUtil } from "@mcleod/core";
import {AutogenLayoutFuelTransactionsProcessing} from "./autogen/AutogenLayoutFuelTransactionsProcessing";
import {Button, ClickEvent, Snackbar, Tab, TableRow, TableRowDisplayEvent} from "@mcleod/components";

export class FuelTransactionsProcessing extends AutogenLayoutFuelTransactionsProcessing {

    onLoad(): void | Promise<void> {
        // Set the Ready to Process tab as the default active tab
        this.tabsetFuelTransactions.selectedIndex = 1;

        // Load data and update tab titles with record counts and totals
        this.layoutReadyToProcess.sourceFuelDetailList.search().then(this.getTabTitleCallback(this.tabReady));
        this.layoutFuelTransactionsHold.sourceFuelDetailList.search().then(this.getTabTitleCallback(this.tabHold));

        this.layoutFuelTransactionsHold.tableFuelTransactions.doOnResolveRowEdit = () => {
            this.reloadAllTabs();
            return null;
        }

        this.layoutReadyToProcess.tableReadyTransactions.doOnResolveRowEdit = () => {
            this.reloadAllTabs();
            return null;
        }

        this.layoutReadyToProcess.buttonHold.addClickListener((event: ClickEvent) =>
            this.holdActionOnClick(event, this.layoutReadyToProcess.tableReadyTransactions.selectedRows, true));

        this.layoutFuelTransactionsHold.buttonRemoveHold.addClickListener((event: ClickEvent) =>
            this.holdActionOnClick(event, this.layoutFuelTransactionsHold.tableFuelTransactions.selectedRows, false));

        this.layoutFuelTransactionsHold.tableFuelTransactions.addRowDisplayListener((event: TableRowDisplayEvent) => {
            this.addTooltips(event.getTableRow());
        });

        this.layoutReadyToProcess.tableReadyTransactions.addRowDisplayListener((event: TableRowDisplayEvent) => {
            this.addTooltips(event.getTableRow());
        });
    }

    searchHoldTab() {
        this.layoutFuelTransactionsHold.sourceFuelDetailList.search().then(this.getTabTitleCallback(this.tabHold));
    }

    searchReadyTab() {
        this.layoutReadyToProcess.sourceFuelDetailList.search().then(this.getTabTitleCallback(this.tabReady));
    }

    private reloadAllTabs() {
        this.searchHoldTab();
        this.searchReadyTab();
    }

    getTabTitleCallback(tab: Tab) {
        if (tab.caption.indexOf("(") > -1) {
            tab.caption = tab.caption.substring(0, tab.caption.indexOf("("));
        }
        return response => {
            if (!response) return;
            const count = response?.modelRows?.length || 0;
            // Use fuel_total as the field to total for fuel transactions
            const totalAmount = response?.summaryData?.getCurrency("fuel_total");

            if (totalAmount) {
                tab.caption = `${tab.caption} (${count}) ${totalAmount}`;
            } else {
                tab.caption = `${tab.caption} (${count})`;
            }
        }
    }

    holdActionOnClick(event: ClickEvent, selectedRows: TableRow[], placeHold: boolean) {
        const button = event.target as Button;
        if (selectedRows.length === 0) {
            Snackbar.showSnackbar("Please select at least one row to update.");
            return;
        }
        const holdMessage = placeHold ? "Place selected transactions on hold?" : "Remove hold from selected transactions?";
        CommonDialogs.showYesNo(holdMessage, "Fuel Transaction Hold").then(async res => {
            if (!!res) {
                let successCount = 0;
                button.busy = true;
                try {
                    await Promise.all(selectedRows.map(async row => {
                        try {
                            row.data.set("is_hold", placeHold);
                            await row.data.post();
                            successCount++;
                        } catch (error) {
                            row.data.revertToOriginalData("is_hold");
                            throw error;
                        }
                    }));
                    Snackbar.showSnackbar(StringUtil.pluralString(successCount, "Fuel Transaction Hold", "Fuel Transaction Holds") + " updated successfully.");
                } finally {
                    button.busy = false;
                    this.reloadAllTabs();
                }
            }
        });
    }

    addTooltips(tableRow: TableRow) {
        const labelPayeeLegalName = tableRow.findComponentById("labelPayeeLegalName");
        CommonTooltips.setTooltipContentLayout(labelPayeeLegalName, tableRow.data.get("payee.id") ,"lme/settlement/SettlementPayeeQuickInfo");
    }

}
